export default [
  {
    version: '1.1.0',
    cmd: '_v',
    call: '/v'
  },
  {
    cmd: 'getOrganizations',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json'
  },
  {
    cmd: 'getOrganizationsWithNonce',
    cmdType: 'nonce',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json',
    call: '/p/apiProxy/registration/v1/registrations/organizations' },
  {
    cmd: 'createOrganization',
    cmdType: 'unsecured',
    call: '/p/apiProxy/organization/v3/organizations',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.v1+json'
  },
  {
    cmd: 'getOrganizationsCount',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'getOrganizationRequests',
    cmdType: 'unsecured',
    call: '/p/apiProxy/organization/v3/organizations/requests',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.request.v1+json'
  },
  {
    cmd: 'approveOrganizationRequests',
    call: '/p/apiProxy/organization/v3/organizations/requests/tasks/approve',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.request.v1+json'
  },
  {
    cmd: 'denyOrganizationRequests',
    call: '/p/apiProxy/organization/v3/organizations/requests/tasks/deny',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.request.v1+json'
  },
  {
    cmd: 'getOrganization',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/{organizationId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json'
  },
  {
    cmd: 'updateOrganization',
    cmdType: 'unsecured',
    call: '/p/apiProxy/organization/v3/organizations/{organizationId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.v1+json'
  },
  {
    cmd: 'getOrganizationHierarchy',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/{organizationId}/hierarchy',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.reference.hierarchy.v1+json;includedivision=true'
  },
  {
    cmd: 'getPersons',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'createPerson',
    call: '/p/apiProxy/person/v3/persons',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'getPersonsAdmins',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json;securityadmin=true'
  },
  {
    cmd: 'countPersons',
    call: '/p/apiProxy/person/v3/persons/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'getPersonRolesOnly',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/roles/{personId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.role.v1+json;onlyroles=true'
  },
  {
    cmd: 'getPersonRoles',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/roles/{personId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.role.v1+json'
  },
  {
    cmd: 'registerPerson',
    cmdType: 'unsecured',
    call: '/p/apiProxy/person/v3/persons/registration',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.password.account.v1+json'
  },
  {
    cmd: 'getRegistrationStatus',
    call: '/p/apiProxy/person/v3/persons/registration/status',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json'
  },
  {
    cmd: 'validateRegistration',
    cmdType: 'unsecured',
    call: '/p/apiProxy/person/v3/persons/registration/validate',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.password.account.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.password.account.v1+json'
  },
  {
    cmd: 'getPersonAttributes',
    call: '/p/apiProxy/person/v3/persons/{personId}/templates',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.attribute.template.v1+json'
  },
  {
    cmd: 'updatePersonAttributes',
    call: '/p/apiProxy/person/v3/persons/{personId}/templates',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.attribute.template.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.attribute.template.v1+json'
  },
  {
    cmd: 'deletePersonAttributes',
    call: '/p/apiProxy/person/v3/persons/{personId}/templates',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.person.attribute.template.v1+json'
  },
  {
    cmd: 'validatePassword',
    cmdType: 'secured',
    call: '/person/v3/persons/password/validate',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.validation.response.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.validation.v1+json'
  },
  {
    cmd: 'getPerson',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/{personId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json;lastlogindate=true'
  },
  {
    cmd: 'updatePerson',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/{personId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'activatePerson',
    call: '/p/apiProxy/person/v3/persons/tasks/activate',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'suspendPerson',
    call: '/p/apiProxy/person/v3/persons/tasks/suspend',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'unsuspendPerson',
    call: '/p/apiProxy/person/v3/persons/tasks/unsuspend',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'getPersonInvitations',
    call: '/p/apiProxy/person/v3/personInvitations',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json'
  },
  {
    cmd: 'createPersonInvitation',
    call: '/p/apiProxy/person/v3/personInvitations',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.invitation.v1+json'
  },
  {
    cmd: 'getPersonInvitation',
    cmdType: 'unsecured',
    call: '/p/apiProxy/person/v3/personInvitations/{invitationId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json'
  },
  {
    cmd: 'deletePersonInvitation',
    cmdType: 'unsecured',
    call: '/p/apiProxy/person/v3/personInvitations/{invitationId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json'
  },
  {
    cmd: 'acceptPersonInvitation',
    call: '/p/apiProxy/person/v3/personInvitations/tasks/accept',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.invitation.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.invitation.v1+json'
  },
  {
    cmd: 'getPersonRequests',
    call: '/p/apiProxy/person/v3/requests',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'createPersonRequest',
    cmdType: 'unsecured',
    call: '/p/apiProxy/person/v3/requests',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'getPersonRequest',
    call: '/p/apiProxy/person/v3/requests/{requestId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'deletePersonRequest',
    call: '/p/apiProxy/person/v3/requests/{requestId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'approvePersonRequest',
    call: '/p/apiProxy/person/v3/requests/tasks/approve',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'denyPersonRequest',
    call: '/p/apiProxy/person/v3/requests/tasks/deny',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.request.v1+json'
  },
  {
    cmd: 'getPersonPassword',
    call: '/p/apiProxy/person/v3/persons/{personId}/accounts/password',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.account.password.v1+json'
  },
  {
    cmd: 'createPersonPassword',
    call: '/p/apiProxy/person/v3/persons/{personId}/accounts/password',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.account.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.account.password.v1+json'
  },
  {
    cmd: 'updatePersonPassword',
    call: '/p/apiProxy/person/v3/persons/{personId}/accounts/password',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.account.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.account.password.v1+json'
  },
  {
    cmd: 'getServices',
    call: '/p/apiProxy/service/v3/services',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.v1+json'
  },
  {
    cmd: 'createService',
    call: '/p/apiProxy/service/v3/services',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.service.v1+json',
    contentType: 'application/vnd.com.covisint.platform.service.v1+json'
  },
  {
    cmd: 'getService',
    call: '/p/apiProxy/service/v3/services/{serviceId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.v1+json'
  },
  {
    cmd: 'getPackageServices',
    call: '/p/apiProxy/service/v3/packages/{packageId}/services',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.v1+json'
  },
  {
    cmd: 'getPackages',
    call: '/p/apiProxy/service/v3/packages',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'getPackageAdmins',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/packages/{packageId}/persons',
    type: 'GET',
    accepts: 'application/json',
    'dataType': 'text'
  },
  {
    cmd: 'addPackageAdmins',
    call: '/p/apiProxy/service/v3/packages/{packageId}/admin/add',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.resource.admin.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.resource.admin.v1+json'
  },
  {
    cmd: 'removePackageAdmins',
    call: '/p/apiProxy/service/v3/packages/{packageId}/admin/remove',
    type: 'POST',
    contentType: 'application/vnd.com.covisint.platform.package.resource.admin.v1+json'
  },
  {
    cmd: 'createPackage',
    call: '/p/apiProxy/service/v3/packages',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'updatePackage',
    call: '/p/apiProxy/service/v3/packages/{packageId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'countPackages',
    call: '/p/apiProxy/service/v3/packages/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'getRequestablePersonPackages',
    call: '/p/apiProxy/service/v3/packages/persons/{personId}/requestable',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'getRequestableOrganizationPackages',
    call: '/p/apiProxy/service/v3/packages/organizations/{organizationId}/requestable',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'getPackage',
    cmdType: 'unsecured',
    call: '/p/apiProxy/service/v3/packages/{packageId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.v1+json'
  },
  {
    cmd: 'assignService',
    call: '/p/apiProxy/service/v3/packages/tasks/assignServiceMembership',
    type: 'POST'
  },
  {
    cmd: 'removeService',
    call: '/p/apiProxy/service/v3/packages/tasks/removeServiceMembership',
    type: 'POST'
  },
  {
    cmd: 'getPersonPackages',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'getPersonPackage',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages/{packageId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'grantPersonPackage',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages/{packageId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'getOrganizationPackages',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/organizations/{organizationId}/packages',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'getOrganizationPackage',
    call: '/p/apiProxy/service/v3/organizations/{organizationId}/packages/{packageId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'grantOrganizationPackage',
    call: '/p/apiProxy/service/v3/organizations/{organizationId}/packages/{packageId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'getPackageRequests',
    call: '/p/apiProxy/service/v3/requests',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json'
  },
  {
    cmd: 'createPackageRequest',
    call: '/p/apiProxy/service/v3/requests',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.request.v1+json'
  },
  {
    cmd: 'getPackageRequest',
    call: '/p/apiProxy/service/v3/requests/{requestId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json'
  },
  {
    cmd: 'deletePackageRequest',
    call: '/p/apiProxy/service/v3/requests/{requestId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json'
  },
  {
    cmd: 'approvePackageRequest',
    call: '/p/apiProxy/service/v3/requests/tasks/approve',
    type: 'POST'
  },
  {
    cmd: 'denyPackageRequest',
    call: '/p/apiProxy/service/v3/requests/tasks/deny',
    type: 'POST'
  },
  {
    cmd: 'getPackageGrants',
    call: '/p/apiProxy/service/v3/grants',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1'
  },
  {
    cmd: 'getPersonClaims',
    call: '/p/apiProxy/service/v3/persons/{personId}/claims',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.claim.v1'
  },
  {
    cmd: 'getPersonPackageClaims',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages/{packageId}/claims',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.claim.v1'
  },
  {
    cmd: 'getGroups',
    call: '/p/apiProxy/group/v2/groups',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements'
  },
  {
    cmd: 'createGroup',
    call: '/p/apiProxy/group/v2/groups',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements',
    contentType: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements'
  },
  {
    cmd: 'getGroup',
    call: '/p/apiProxy/group/v2/groups/{groupId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements'
  },
  {
    cmd: 'updateGroup',
    call: '/p/apiProxy/group/v2/groups/{groupId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements',
    contentType: 'application/vnd.com.covisint.platform.group.v1+json;includeEntitlements'
  },
  {
    cmd: 'getGroupEntitlements',
    call: '/p/apiProxy/group/v2/groups/{groupId}/entitlements',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.entitlement.v1+json'
  },
  {
    cmd: 'createGroupEntitlement',
    call: '/p/apiProxy/group/v2/groups/{groupId}/entitlements',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.group.entitlement.v1+json',
    contentType: 'application/vnd.com.covisint.platform.group.entitlement.v1+json'
  },
  {
    cmd: 'getGroupEntitlement',
    call: '/p/apiProxy/group/v2/groups/{groupId}/entitlements/{groupEntitlementId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.entitlement.v1+json'
  },
  {
    cmd: 'deleteGroupEntitlement',
    call: '/p/apiProxy/group/v2/groups/{groupId}/entitlements/{groupEntitlementId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.group.entitlement.v1+json'
  },
  {
    cmd: 'createGroupMemberships',
    call: '/p/apiProxy/group/v2/groups/{groupId}/memberships',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.group.membership.v1+json',
    contentType: 'application/vnd.com.covisint.platform.group.membership.v1+json'
  },
  {
    cmd: 'getGroupMemberships',
    call: '/p/apiProxy/group/v2/groups/{groupId}/memberships',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.membership.v1+json;includeGroupAndEntitlements;includeGroup'
  },
  {
    cmd: 'getGroupMembership',
    call: '/p/apiProxy/group/v2/groups/{groupId}/memberships/{groupMembershipId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.membership.v1+json'
  },
  {
    cmd: 'deleteGroupMembership',
    call: '/p/apiProxy/group/v2/groups/{groupId}/memberships/{groupMembershipId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.group.membership.v1+json'
  },
  {
    cmd: 'getMemberMemberships',
    call: '/p/apiProxy/group/v2/memberships',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.group.membership.v1+json;includeGroupAndEntitlements;includeGroup'
  },
  {
    cmd: 'getSecurityQuestions',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/securityQuestions',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.securityquestion.v1+json'
  },
  {
    cmd: 'createSecurityQuestions',
    call: '/p/apiProxy/authn/v4/securityQuestions/{personId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.securityquestion.v1+json',
    contentType: 'application/vnd.com.covisint.platform.securityquestion.v1+json'
  },
  {
    cmd: 'updateSecurityQuestions',
    call: '/p/apiProxy/authn/v4/securityQuestions/{personId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.securityquestion.v1+json',
    contentType: 'application/vnd.com.covisint.platform.securityquestion.v1+json'
  },
  {
    cmd: 'authnNonceValidate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/authn/v4/authn/nonce/validate',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.authn.nonce.v1+json',
    contentType: 'application/vnd.com.covisint.platform.authn.nonce.v1+json'
  },
  {
    cmd: 'sessionNonceValidate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/authn/v4/sessionToken/nonce/validate',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.nonce.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.nonce.request.v1+json'
  },
  {
    cmd: 'getSecurityQuestionAccount',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/persons/{personId}/accounts/securityQuestion',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.account.securityQuestion.v1+json'
  },
  {
    cmd: 'createSecurityQuestionAccount',
    call: '/p/apiProxy/authn/v4/persons/{personId}/accounts/securityQuestion',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.account.securityQuestion.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.account.securityQuestion.v1+json'
  },
  {
    cmd: 'updateSecurityQuestionAccount',
    call: '/p/apiProxy/authn/v4/persons/{personId}/accounts/securityQuestion',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.person.account.securityQuestion.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.account.securityQuestion.v1+json'
  },
  {
    cmd: 'authenticatePassword',
    call: '/p/apiProxy/authn/v4/passwords/tasks/authenticate',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.authn.password.resp.v1+json',
    contentType: 'application/vnd.com.covisint.platform.authn.password.resp.v1+json'
  },
  {
    cmd: 'lockPassword',
    call: '/p/apiProxy/authn/v4/passwords/tasks/lock',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.v1+json'
  },
  {
    cmd: 'unlockPassword',
    call: '/p/apiProxy/authn/v4/passwords/tasks/unlock',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.v1+json'
  },
  {
    cmd: 'getPasswordPolicies',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/passwords/policies',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json'
  },
  {
    cmd: 'createPasswordPolicies',
    call: '/p/apiProxy/authn/v4/passwords/policies',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.policy.v1+json'
  },
  {
    cmd: 'getPasswordPolicy',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/passwords/policies/{policyId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json'
  },
  {
    cmd: 'deletePasswordPolicy',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/passwords/policies/{policyId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.password.policy.v1+json'
  },
  {
    cmd: 'getAttributes',
    call: '/p/apiProxy/attributes/v1/attributes',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.attribute.v1+json'
  },
  {
    cmd: 'createAttribute',
    call: '/p/apiProxy/attributes/v1/attributes',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.attribute.v1+json',
    contentType: 'application/vnd.com.covisint.platform.attribute.v1+json'
  },
  {
    cmd: 'getAttribute',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributes/{attributeId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.attribute.v1+json'
  },
  {
    cmd: 'updateAttribute',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributes/{attributeId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.attribute.v1+json',
    contentType: 'application/vnd.com.covisint.platform.attribute.v1+json'
  },
  {
    cmd: 'deleteAttribute',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributes/{attributeId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.attribute.v1+json'
  },
  {
    cmd: 'getAttributeTemplates',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributeTemplates',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json'
  },
  {
    cmd: 'getAttributeTemplate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributeTemplates/{attributeTemplateId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json'
  },
  {
    cmd: 'deleteAttributeTemplate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributeTemplates/{attributeTemplateId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json'
  },
  {
    cmd: 'createAttributeTemplate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributeTemplates/{attributeTemplateId}',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json',
    contentType: 'application/vnd.com.covisint.platform.attribute.template.v1+json'
  },
  {
    cmd: 'updateAttributeTemplate',
    cmdType: 'unsecured',
    call: '/p/apiProxy/attributes/v1/attributeTemplates/{attributeTemplateId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.attribute.template.v1+json',
    contentType: 'application/vnd.com.covisint.platform.attribute.template.v1+json'
  },
  {
    cmd: 'getAuthenticationPolicy',
    cmdType: 'secured',
    call: '/p/apiProxy/authn/v4/policies/{policyId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.authn.policy.v1+json'
  },
  {
    cmd: 'getOrganizationWithAttributes',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/{organizationId}',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.v1+json;getextendedattributes=true'
  },
  {
    cmd: 'getPersonDetailedStatusHistory',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/person/detailedStatusHistory',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.detail.status.history.v1+json'
  },
  {
    cmd: 'getPersonTacOfPackage',
    cmdType: 'unsecured',
    call: '/p/apiProxy/service/v3/packages/{packageId}/persons/tacs',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.terms.and.condition.v1+json'
  },
  {
    cmd: 'getOrgTacOfPackage',
    call: '/p/apiProxy/service/v3/packages/{packageId}/organizations/tacs',
    type: 'GET',
    cmdType: 'unsecured',
    accepts: 'application/vnd.com.covisint.platform.package.terms.and.condition.v1+json'
  },
  {
    cmd: 'getPersonTacOfPackageByLangId',
    call: '/p/apiProxy/service/v3/packages/{packageId}/persons/tacs/languages/{languageId}',
    type: 'GET',
    cmdType: 'unsecured',
    accepts: 'application/vnd.com.covisint.platform.package.terms.and.condition.v1+json'
  },
  {
    cmd: 'getOrgTacOfPackageByLangId',
    call: '/p/apiProxy/service/v3/packages/{packageId}/organizations/tacs/languages/{languageId}',
    type: 'GET',
    cmdType: 'unsecured',
    accepts: 'application/vnd.com.covisint.platform.package.terms.and.condition.v1+json'
  },
  {
    cmd: 'getPasswordChangeHistory',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/{personId}/accounts/password/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.authn.password.change.history.req.v1+json'
  },
  {
    cmd: 'getPersonAppCategories',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/categories/persons/{personId} ',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.category.v1+json'
  },
  {
    cmd: 'getPersonPackagesGrantHistory',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.grant.v1+json'
  },
  {
    cmd: 'getPersonApplicationsGrantHistory',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.grant.history.v1+json'
  },
  {
    cmd: 'getPersonApplicationsRequestHistory',
    call: '/p/apiProxy/service/v3/persons/{personId}/applications/requests/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.request.history.v1+json'
  },
  {
    cmd: 'getPersonApplicationsGrantHistoryCount',
    call: '/p/apiProxy/service/v3/applications/persons/{personId}/history/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'getPersonApplicationsRequestHistoryCount',
    call: '/p/apiProxy/service/v3/persons/{personId}/applications/requests/history/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'getPersonPendingApps',
    call: '/p/apiProxy/service/v3/persons/{personId}/applications/requests',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.request.v1+json'
  },
  {
    cmd: 'getOrganizationsRequestableApps',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/requestable',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.v1+json'
  },
  {
    cmd: 'createOrgCompanyInvitation',
    call: '/p/apiProxy/organization/v3/organizationInvitations/company',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.invitation.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.invitation.v1+json'
  },
  {
    cmd: 'createOrgDivisionInvitation',
    call: '/p/apiProxy/organization/v3/organizationInvitations/division',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.organization.invitation.v1+json',
    contentType: 'application/vnd.com.covisint.platform.organization.invitation.v1+json'
  },
  {
    cmd: 'getOrganizationSecurityAdmins',
    call: '/p/apiProxy/person/v3/persons/organizations/{organizationId}/securityAdmins',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.v1+json'
  },
  {
    cmd: 'getOrgAppCategories',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/categories/organization/{organizationId} ',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.category.v1+json'
  },
  {
    cmd: 'suspendPersonApp',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/grants/tasks/person/package/suspend',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json'
  },
  {
    cmd: 'unsuspendPersonApp',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/grants/tasks/person/package/unsuspend',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.grant.status.request.v1+json'
  },
  {
    cmd: 'resetPersonPassword',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: ' application/vnd.com.covisint.platform.password.v1+json',
    call: '/p/apiProxy/authn/v4/passwords/tasks/reset'
  },
  {
    cmd: 'expirePersonPassword',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.v1+json',
    call: '/p/apiProxy/authn/v4/passwords/tasks/expire'
  },
  {
    cmd: 'specifyPersonPassword',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: 'application/vnd.com.covisint.platform.password.v1+json',
    call: '/p/apiProxy/authn/v4/passwords/tasks/specify'
  },
  {
    cmd: 'revokePersonApp',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/persons/{personId}/packages/{packageId}',
    type: 'DELETE'
  },
  {
    cmd: 'retriveOrgPendingApps',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/organizations/requests',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.package.request.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.request.v1+json'
  },
  {
    cmd: 'getPersonRolesGrantable',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/{personId}/roles/grantable',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.person.role.v1+json'
  },
  {
    cmd: 'assignPersonRoles',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/roles',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.person.assign.role.v1+json',
    contentType: 'application/vnd.com.covisint.platform.person.assign.role.v1+json'
  },
  {
    cmd: 'unlockPersonPassword',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.password.v1+json',
    contentType: ' application/vnd.com.covisint.platform.password.v1+json',
    call: '/p/apiProxy/authn/v4/passwords/tasks/unlock'
  },
  {
    cmd: 'retriveOrgPendingAppsCount',
    cmdType: 'secured',
    call: '/p/apiProxy/service/v3/organizations/requests/count',
    type: 'GET',
    accepts: 'text/plain'
  },
  {
    cmd: 'removePersonRoles',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/remove/roles',
    type: 'POST',
    contentType: 'application/vnd.com.covisint.platform.person.delete.role.v1+json',
    accepts: 'application/vnd.com.covisint.platform.person.delete.role.v1+json'
  },
  {
    cmd: 'suspendOrg',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/tasks/suspend',
    type: 'POST'
  },
  {
    cmd: 'unsuspendOrg',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/tasks/unsuspend',
    type: 'POST'
  },
  {
    cmd: 'removeOrg',
    cmdType: 'secured',
    call: '/p/apiProxy/organization/v3/organizations/tasks/remove',
    type: 'POST'
  },
  {
    cmd: 'getOrgAppsGrantHistory',
    call: '/p/apiProxy/service/v3/applications/organizations/{organizationId}/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.grant.history.v1+json'
  },
  {
    cmd: 'getOrgAppsRequestHistory',
    call: '/p/apiProxy/service/v3/organizations/{organizationId}/applications/requests/history',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.service.application.request.history.v1+json'
  },
  {
    cmd: 'getOrgstatusHistory',
    call: '/p/apiProxy/organization/v3/organizations/statusHistory',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.organization.status.history.v1+json'
  },
  {
    cmd: 'removePerson',
    cmdType: 'secured',
    call: '/p/apiProxy/person/v3/persons/{personId}',
    type: 'DELETE'
  },
  {

    cmd: 'AddoAuth2',
    cmdType: 'secured',
    call: '/p/apiProxy/social-accounts/v1/social',
    type: 'POST',
    contentType: 'application/json'
  },
  {
    cmd: 'getOAuth2',
    cmdType: 'secured',
    call: '/p/apiProxy/social-accounts/v1/social',
    type: 'GET',
    contentType: 'application/json'
  },
  {
    cmd: 'getScimClientConfigurations',
    cmdType: 'secured',
    call: '/p/apiProxy/scim/v2/ClientConfiguration',
    type: 'GET',
    accepts: 'application/json'
  },
  {
    cmd: 'createScimClientConfiguration',
    cmdType: 'secured',
    call: '/p/apiProxy/scim/v2/ClientConfiguration',
    type: 'POST',
    accepts: 'application/json',
    contentType: 'application/json'
  },
  {
    cmd: 'deleteScimClientConfiguration',
    cmdType: 'secured',
    call: '/p/apiProxy/scim/v2/ClientConfiguration/{clientId}',
    type: 'DELETE',
    contentType: 'application/json'
  },
  {
    cmd: 'addPackageClaims',
    call: '/p/apiProxy/service/v3/claims',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'
  },
  {
    cmd: 'updatePackageClaims',
    call: '/p/apiProxy/service/v3/claims/{claimId}',
    type: 'PUT',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'
  },
  {
    cmd: 'deletePackageClaims',
    call: '/p/apiProxy/service/v3/packages/{packageId}/claims/{claimId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'
  },
  {
    cmd: 'deletePackageClaimsWithGrants',
    call: '/p/apiProxy/service/v3/packages/{packageId}/claims/{claimId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json;deleteuserpkggrant=true',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'
  },
  {
    cmd: 'deletePackageClaimsValue',
    call: '/p/apiProxy/service/v3/packages/{packageId}/claims/{claimId}/claimValue/{valueId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'
  },
  {
    cmd: 'deletePackageClaimsValueWithGrants',
    call: '/p/apiProxy/service/v3/packages/{packageId}/claims/{claimId}/claimValue/{valueId}',
    type: 'DELETE',
    accepts: 'application/vnd.com.covisint.platform.package.claim.v1+json;deleteuserpkgvaluegrant=true',
    contentType: 'application/vnd.com.covisint.platform.package.claim.v1+json'

  },
  {
    cmd: 'getScimConnectorConfigurations',
    call: '/p/apiProxy/scim/v2/ConnectorConfiguration',
    cmdType: 'secured',
    type: 'GET',
    accepts: 'application/json',
    contentType: 'application/json'
  },
  {
    cmd: 'addScimConnectorConfiguration',
    call: '/p/apiProxy/scim/v2/ConnectorConfiguration',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/json',
    contentType: 'application/json'
  },
  {
    cmd: 'updateScimConnectorConfiguration',
    call: '/p/apiProxy/scim/v2/ConnectorConfiguration/{id}',
    cmdType: 'secured',
    type: 'PUT',
    accepts: 'application/json',
    contentType: 'application/json'
  },
  {
    cmd: 'deleteScimConnectorConfiguration',
    call: '/p/apiProxy/scim/v2/ConnectorConfiguration/{id}',
    cmdType: 'secured',
    type: 'DELETE',
    accepts: 'application/json',
    contentType: 'application/json'
  },
  {
    cmd: 'impersonateUser',
    call: '/p/apiProxy/impersonate',
    type: 'POST',
    contentType: 'application/json'

  },
  {
    cmd: 'endImpersonation',
    call: '/p/apiProxy/impersonate/stop',
    type: 'POST',
    contentType: 'application/json'

  },
  {
    cmd: 'getAvailableMfa',
    call: '/p/apiProxy/authn/v4/mfa/persons/{id}/modes',
    cmdType: 'secured',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.modes.v1+json'
  },
  {
    cmd: 'getPreferedMfa',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/mode',
    cmdType: 'secured',
    type: 'GET',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.mode.v1+json'
  },
  {
    cmd: 'sendSMSCode',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=SMS&phoneType=PHONE',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'verifyMFA',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/register',
    cmdType: 'secured',
    type: 'POST',
    contentType: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'sendEmailCode',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=EMAIL',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'sendIDCipher',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=GRIDCARD',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'sendNewIDCipher',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=GRIDCARD&action=SEND_GRID',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'getTOTP',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=GA&action=SEND_GA',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'callPhone',
    call: '/p/apiProxy/mfa/v1/mfa/persons/{id}/token?mode=PHONE&phoneType=PHONE',
    cmdType: 'secured',
    type: 'POST',
    accepts: 'application/vnd.com.covisint.platform.mfa.user.v1+json'
  },
  {
    cmd: 'deleteOauth2',
    call: '/p/apiProxy/social-accounts/v1/social/{name}',
    cmdType: 'secured',
    type: 'DELETE',
    accepts: 'application/json'
  },
  {
    cmd: 'getCategories',
    cmdType: 'secured',
    accepts: 'application/vnd.com.covisint.platform.category.v1+json',
    call: '/p/apiProxy/service/v3/categories',
    type: 'GET'
  }

]



// WEBPACK FOOTER //
// ./src/plugins/IDMAPI.js